export const CORE_TRAVELER_NAME = "core-traveler";

export enum CoreTravelerComponent {
  TravelerList = "TravelerList",
  TravelerListItem = "TravelerListItem",
  TravelerForm = "TravelerForm",
  TravelerEdit = "TravelerEdit",
  TravelerDelete = "TravelerDelete",
  TravelerAdd = "TravelerAdd",
  TravelerFormDialog = "TravelerFormDialog",
}
